/**
 * T&R Kpler service REST API
 * Trading & Risk Kpler service RESTful Application Programming Interface
 *
 * The version of the OpenAPI document: 2.3
 * Contact: gcb-rt@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

import { SnapshotDetailDTO } from '../model/models';
import { SnapshotSummaryDTO } from '../model/models';
import { SnapshotType } from '../model/models';
import { TimeFrame } from '../model/models';
import { TimePeriod } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { KplerAPIConfiguration } from '../configuration';
import {
    PublicSnapshotControllerServiceInterface,
    GetAggregatedFlowsDetailsRequestParams,
    GetAggregatedFlowsSummaryRequestParams,
    GetCommodityGroupsRequestParams,
    GetGranularitiesRequestParams,
    GetInventoriesDetailsRequestParams,
    GetInventoriesSummaryRequestParams,
    GetProductFamiliesRequestParams
} from './publicSnapshotController.serviceInterface';

@Injectable({
    providedIn: 'root'
})
export class PublicSnapshotControllerService implements PublicSnapshotControllerServiceInterface {
    protected basePath = 'http://localhost/api/kpler';
    public defaultHeaders = new HttpHeaders();
    public configuration = new KplerAPIConfiguration();
    public encoder: HttpParameterCodec;

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string,
        @Optional() configuration: KplerAPIConfiguration
    ) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === 'object' && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === 'object') {
            if (Array.isArray(value)) {
                (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                    throw Error('key may not be null if value is Date');
                }
            } else {
                Object.keys(value).forEach(k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error('key may not be null if value is not object or array');
        }
        return httpParams;
    }

    /**
     * Get Aggregated Flows Details
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAggregatedFlowsDetails(
        requestParameters: GetAggregatedFlowsDetailsRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<Array<SnapshotDetailDTO>>;
    public getAggregatedFlowsDetails(
        requestParameters: GetAggregatedFlowsDetailsRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpResponse<Array<SnapshotDetailDTO>>>;
    public getAggregatedFlowsDetails(
        requestParameters: GetAggregatedFlowsDetailsRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpEvent<Array<SnapshotDetailDTO>>>;
    public getAggregatedFlowsDetails(
        requestParameters: GetAggregatedFlowsDetailsRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<any> {
        const commodityGroup = requestParameters.commodityGroup;
        if (commodityGroup === null || commodityGroup === undefined) {
            throw new Error('Required parameter commodityGroup was null or undefined when calling getAggregatedFlowsDetails.');
        }
        const productFamily = requestParameters.productFamily;
        if (productFamily === null || productFamily === undefined) {
            throw new Error('Required parameter productFamily was null or undefined when calling getAggregatedFlowsDetails.');
        }
        const granularity = requestParameters.granularity;
        if (granularity === null || granularity === undefined) {
            throw new Error('Required parameter granularity was null or undefined when calling getAggregatedFlowsDetails.');
        }
        const decimals = requestParameters.decimals;
        if (decimals === null || decimals === undefined) {
            throw new Error('Required parameter decimals was null or undefined when calling getAggregatedFlowsDetails.');
        }
        const date = requestParameters.date;

        let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
        if (commodityGroup !== undefined && commodityGroup !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>commodityGroup, 'commodityGroup');
        }
        if (productFamily !== undefined && productFamily !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>productFamily, 'productFamily');
        }
        if (date !== undefined && date !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>date, 'date');
        }
        if (granularity !== undefined && granularity !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>granularity, 'granularity');
        }
        if (decimals !== undefined && decimals !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>decimals, 'decimals');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (oauth) required
        localVarCredential = this.configuration.lookupCredential('oauth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['*/*'];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let responseType_: 'text' | 'json' = 'json';
        if (localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<SnapshotDetailDTO>>(`${this.configuration.basePath}/snapshots/aggregated-flow-details`, {
            context: localVarHttpContext,
            params: localVarQueryParameters,
            responseType: <any>responseType_,
            withCredentials: this.configuration.withCredentials,
            headers: localVarHeaders,
            observe: observe,
            reportProgress: reportProgress
        });
    }

    /**
     * Get Aggregated Flows Summary
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAggregatedFlowsSummary(
        requestParameters: GetAggregatedFlowsSummaryRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<Array<SnapshotSummaryDTO>>;
    public getAggregatedFlowsSummary(
        requestParameters: GetAggregatedFlowsSummaryRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpResponse<Array<SnapshotSummaryDTO>>>;
    public getAggregatedFlowsSummary(
        requestParameters: GetAggregatedFlowsSummaryRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpEvent<Array<SnapshotSummaryDTO>>>;
    public getAggregatedFlowsSummary(
        requestParameters: GetAggregatedFlowsSummaryRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<any> {
        const commodityGroup = requestParameters.commodityGroup;
        if (commodityGroup === null || commodityGroup === undefined) {
            throw new Error('Required parameter commodityGroup was null or undefined when calling getAggregatedFlowsSummary.');
        }
        const productFamily = requestParameters.productFamily;
        if (productFamily === null || productFamily === undefined) {
            throw new Error('Required parameter productFamily was null or undefined when calling getAggregatedFlowsSummary.');
        }
        const granularity = requestParameters.granularity;
        if (granularity === null || granularity === undefined) {
            throw new Error('Required parameter granularity was null or undefined when calling getAggregatedFlowsSummary.');
        }
        const decimals = requestParameters.decimals;
        if (decimals === null || decimals === undefined) {
            throw new Error('Required parameter decimals was null or undefined when calling getAggregatedFlowsSummary.');
        }
        const startDate = requestParameters.startDate;
        const endDate = requestParameters.endDate;
        const timeFrame = requestParameters.timeFrame;

        let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
        if (commodityGroup !== undefined && commodityGroup !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>commodityGroup, 'commodityGroup');
        }
        if (productFamily !== undefined && productFamily !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>productFamily, 'productFamily');
        }
        if (startDate !== undefined && startDate !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'startDate');
        }
        if (endDate !== undefined && endDate !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'endDate');
        }
        if (timeFrame !== undefined && timeFrame !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>timeFrame, 'timeFrame');
        }
        if (granularity !== undefined && granularity !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>granularity, 'granularity');
        }
        if (decimals !== undefined && decimals !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>decimals, 'decimals');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (oauth) required
        localVarCredential = this.configuration.lookupCredential('oauth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['*/*'];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let responseType_: 'text' | 'json' = 'json';
        if (localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<SnapshotSummaryDTO>>(`${this.configuration.basePath}/snapshots/aggregated-flow-summaries`, {
            context: localVarHttpContext,
            params: localVarQueryParameters,
            responseType: <any>responseType_,
            withCredentials: this.configuration.withCredentials,
            headers: localVarHeaders,
            observe: observe,
            reportProgress: reportProgress
        });
    }

    /**
     * Get available commodities groups
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCommodityGroups(
        requestParameters: GetCommodityGroupsRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<Array<string>>;
    public getCommodityGroups(
        requestParameters: GetCommodityGroupsRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpResponse<Array<string>>>;
    public getCommodityGroups(
        requestParameters: GetCommodityGroupsRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpEvent<Array<string>>>;
    public getCommodityGroups(
        requestParameters: GetCommodityGroupsRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<any> {
        const snapshotType = requestParameters.snapshotType;
        if (snapshotType === null || snapshotType === undefined) {
            throw new Error('Required parameter snapshotType was null or undefined when calling getCommodityGroups.');
        }

        let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
        if (snapshotType !== undefined && snapshotType !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>snapshotType, 'snapshotType');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (oauth) required
        localVarCredential = this.configuration.lookupCredential('oauth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['*/*'];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let responseType_: 'text' | 'json' = 'json';
        if (localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/snapshots/commodity-groups`, {
            context: localVarHttpContext,
            params: localVarQueryParameters,
            responseType: <any>responseType_,
            withCredentials: this.configuration.withCredentials,
            headers: localVarHeaders,
            observe: observe,
            reportProgress: reportProgress
        });
    }

    /**
     * Get available granularities
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGranularities(
        requestParameters: GetGranularitiesRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<Array<TimePeriod>>;
    public getGranularities(
        requestParameters: GetGranularitiesRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpResponse<Array<TimePeriod>>>;
    public getGranularities(
        requestParameters: GetGranularitiesRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpEvent<Array<TimePeriod>>>;
    public getGranularities(
        requestParameters: GetGranularitiesRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<any> {
        const snapshotType = requestParameters.snapshotType;
        if (snapshotType === null || snapshotType === undefined) {
            throw new Error('Required parameter snapshotType was null or undefined when calling getGranularities.');
        }
        const commodityGroup = requestParameters.commodityGroup;
        if (commodityGroup === null || commodityGroup === undefined) {
            throw new Error('Required parameter commodityGroup was null or undefined when calling getGranularities.');
        }
        const family = requestParameters.family;
        if (family === null || family === undefined) {
            throw new Error('Required parameter family was null or undefined when calling getGranularities.');
        }

        let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
        if (snapshotType !== undefined && snapshotType !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>snapshotType, 'snapshotType');
        }
        if (commodityGroup !== undefined && commodityGroup !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>commodityGroup, 'commodityGroup');
        }
        if (family !== undefined && family !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>family, 'family');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (oauth) required
        localVarCredential = this.configuration.lookupCredential('oauth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['*/*'];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let responseType_: 'text' | 'json' = 'json';
        if (localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<TimePeriod>>(`${this.configuration.basePath}/snapshots/granularities`, {
            context: localVarHttpContext,
            params: localVarQueryParameters,
            responseType: <any>responseType_,
            withCredentials: this.configuration.withCredentials,
            headers: localVarHeaders,
            observe: observe,
            reportProgress: reportProgress
        });
    }

    /**
     * Get Inventories Details
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInventoriesDetails(
        requestParameters: GetInventoriesDetailsRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<Array<SnapshotDetailDTO>>;
    public getInventoriesDetails(
        requestParameters: GetInventoriesDetailsRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpResponse<Array<SnapshotDetailDTO>>>;
    public getInventoriesDetails(
        requestParameters: GetInventoriesDetailsRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpEvent<Array<SnapshotDetailDTO>>>;
    public getInventoriesDetails(
        requestParameters: GetInventoriesDetailsRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<any> {
        const granularity = requestParameters.granularity;
        if (granularity === null || granularity === undefined) {
            throw new Error('Required parameter granularity was null or undefined when calling getInventoriesDetails.');
        }
        const commodityGroup = requestParameters.commodityGroup;
        if (commodityGroup === null || commodityGroup === undefined) {
            throw new Error('Required parameter commodityGroup was null or undefined when calling getInventoriesDetails.');
        }
        const productFamily = requestParameters.productFamily;
        if (productFamily === null || productFamily === undefined) {
            throw new Error('Required parameter productFamily was null or undefined when calling getInventoriesDetails.');
        }
        const decimals = requestParameters.decimals;
        if (decimals === null || decimals === undefined) {
            throw new Error('Required parameter decimals was null or undefined when calling getInventoriesDetails.');
        }
        const date = requestParameters.date;

        let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
        if (granularity !== undefined && granularity !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>granularity, 'granularity');
        }
        if (commodityGroup !== undefined && commodityGroup !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>commodityGroup, 'commodityGroup');
        }
        if (productFamily !== undefined && productFamily !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>productFamily, 'productFamily');
        }
        if (date !== undefined && date !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>date, 'date');
        }
        if (decimals !== undefined && decimals !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>decimals, 'decimals');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (oauth) required
        localVarCredential = this.configuration.lookupCredential('oauth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['*/*'];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let responseType_: 'text' | 'json' = 'json';
        if (localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<SnapshotDetailDTO>>(`${this.configuration.basePath}/snapshots/global-inventory-details`, {
            context: localVarHttpContext,
            params: localVarQueryParameters,
            responseType: <any>responseType_,
            withCredentials: this.configuration.withCredentials,
            headers: localVarHeaders,
            observe: observe,
            reportProgress: reportProgress
        });
    }

    /**
     * Get Inventories Summary
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInventoriesSummary(
        requestParameters: GetInventoriesSummaryRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<Array<SnapshotSummaryDTO>>;
    public getInventoriesSummary(
        requestParameters: GetInventoriesSummaryRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpResponse<Array<SnapshotSummaryDTO>>>;
    public getInventoriesSummary(
        requestParameters: GetInventoriesSummaryRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpEvent<Array<SnapshotSummaryDTO>>>;
    public getInventoriesSummary(
        requestParameters: GetInventoriesSummaryRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<any> {
        const commodityGroup = requestParameters.commodityGroup;
        if (commodityGroup === null || commodityGroup === undefined) {
            throw new Error('Required parameter commodityGroup was null or undefined when calling getInventoriesSummary.');
        }
        const productFamily = requestParameters.productFamily;
        if (productFamily === null || productFamily === undefined) {
            throw new Error('Required parameter productFamily was null or undefined when calling getInventoriesSummary.');
        }
        const granularity = requestParameters.granularity;
        if (granularity === null || granularity === undefined) {
            throw new Error('Required parameter granularity was null or undefined when calling getInventoriesSummary.');
        }
        const decimals = requestParameters.decimals;
        if (decimals === null || decimals === undefined) {
            throw new Error('Required parameter decimals was null or undefined when calling getInventoriesSummary.');
        }
        const startDate = requestParameters.startDate;
        const endDate = requestParameters.endDate;
        const timeFrame = requestParameters.timeFrame;

        let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
        if (commodityGroup !== undefined && commodityGroup !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>commodityGroup, 'commodityGroup');
        }
        if (productFamily !== undefined && productFamily !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>productFamily, 'productFamily');
        }
        if (startDate !== undefined && startDate !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'startDate');
        }
        if (endDate !== undefined && endDate !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'endDate');
        }
        if (timeFrame !== undefined && timeFrame !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>timeFrame, 'timeFrame');
        }
        if (granularity !== undefined && granularity !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>granularity, 'granularity');
        }
        if (decimals !== undefined && decimals !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>decimals, 'decimals');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (oauth) required
        localVarCredential = this.configuration.lookupCredential('oauth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['*/*'];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let responseType_: 'text' | 'json' = 'json';
        if (localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<SnapshotSummaryDTO>>(`${this.configuration.basePath}/snapshots/global-inventory-summaries`, {
            context: localVarHttpContext,
            params: localVarQueryParameters,
            responseType: <any>responseType_,
            withCredentials: this.configuration.withCredentials,
            headers: localVarHeaders,
            observe: observe,
            reportProgress: reportProgress
        });
    }

    /**
     * Get available product families
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductFamilies(
        requestParameters: GetProductFamiliesRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<Array<string>>;
    public getProductFamilies(
        requestParameters: GetProductFamiliesRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpResponse<Array<string>>>;
    public getProductFamilies(
        requestParameters: GetProductFamiliesRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpEvent<Array<string>>>;
    public getProductFamilies(
        requestParameters: GetProductFamiliesRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<any> {
        const snapshotType = requestParameters.snapshotType;
        if (snapshotType === null || snapshotType === undefined) {
            throw new Error('Required parameter snapshotType was null or undefined when calling getProductFamilies.');
        }
        const commodityGroup = requestParameters.commodityGroup;
        if (commodityGroup === null || commodityGroup === undefined) {
            throw new Error('Required parameter commodityGroup was null or undefined when calling getProductFamilies.');
        }

        let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
        if (snapshotType !== undefined && snapshotType !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>snapshotType, 'snapshotType');
        }
        if (commodityGroup !== undefined && commodityGroup !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>commodityGroup, 'commodityGroup');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (oauth) required
        localVarCredential = this.configuration.lookupCredential('oauth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['*/*'];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let responseType_: 'text' | 'json' = 'json';
        if (localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<string>>(`${this.configuration.basePath}/snapshots/product-families`, {
            context: localVarHttpContext,
            params: localVarQueryParameters,
            responseType: <any>responseType_,
            withCredentials: this.configuration.withCredentials,
            headers: localVarHeaders,
            observe: observe,
            reportProgress: reportProgress
        });
    }

    /**
     * Get available snapshots
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSnapshotTypes(
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<Array<SnapshotType>>;
    public getSnapshotTypes(
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpResponse<Array<SnapshotType>>>;
    public getSnapshotTypes(
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpEvent<Array<SnapshotType>>>;
    public getSnapshotTypes(
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<any> {
        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (oauth) required
        localVarCredential = this.configuration.lookupCredential('oauth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['*/*'];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let responseType_: 'text' | 'json' = 'json';
        if (localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<SnapshotType>>(`${this.configuration.basePath}/snapshots/snapshot-types`, {
            context: localVarHttpContext,
            responseType: <any>responseType_,
            withCredentials: this.configuration.withCredentials,
            headers: localVarHeaders,
            observe: observe,
            reportProgress: reportProgress
        });
    }

    /**
     * Get available time frames
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTimeFrames(
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<Array<TimeFrame>>;
    public getTimeFrames(
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpResponse<Array<TimeFrame>>>;
    public getTimeFrames(
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<HttpEvent<Array<TimeFrame>>>;
    public getTimeFrames(
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: '*/*'; context?: HttpContext }
    ): Observable<any> {
        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (oauth) required
        localVarCredential = this.configuration.lookupCredential('oauth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['*/*'];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let responseType_: 'text' | 'json' = 'json';
        if (localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<TimeFrame>>(`${this.configuration.basePath}/snapshots/time-frames`, {
            context: localVarHttpContext,
            responseType: <any>responseType_,
            withCredentials: this.configuration.withCredentials,
            headers: localVarHeaders,
            observe: observe,
            reportProgress: reportProgress
        });
    }
}
